import React from 'react';

export default React.memo(function Paragraph({ className = '', children }) {
  return (
    <p className={`text-gray text-xl leading-7 w-full whitespace-pre-line ${className}`}>
      {children}
    </p>
  );
});
